import { render } from "./SoldPendingStatus.vue?vue&type=template&id=fde09884"
import script from "./SoldPendingStatus.vue?vue&type=script&lang=js"
export * from "./SoldPendingStatus.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__